import { render, staticRenderFns } from "./AdminsItem.vue?vue&type=template&id=35a265f3&"
import script from "./AdminsItem.vue?vue&type=script&lang=ts&"
export * from "./AdminsItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdminsItem.vue?vue&type=style&index=0&id=35a265f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports